<template>
  <div class="PasswordResetView flex flex-col lg-justify-center">
    <router-view></router-view>
  </div>
</template>

<script setup></script>
